import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

export const Header = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goQuote = () => {
    const el = document.getElementById("quote");
    if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -60 });
    else if (el) el.scrollIntoView();
  };

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 bg-[#171914]/85 backdrop-blur-xl backdrop-saturate-150 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex items-center">
          <img src="/logo.png" alt="Infinite Siding LLC" className="h-9 w-auto logo-on-dark" />
        </Link>
        <nav className="flex items-center gap-5 md:gap-8 text-xs md:text-sm font-semibold tracking-widest uppercase">
          <Link
            to="/residential"
            data-testid="nav-residential"
            className={`transition-colors duration-300 hover:text-primary ${pathname === "/residential" ? "text-primary" : "text-white/70"}`}
          >
            Residential
          </Link>
          <Link
            to="/commercial"
            data-testid="nav-commercial"
            className={`transition-colors duration-300 hover:text-primary ${pathname === "/commercial" ? "text-primary" : "text-white/70"}`}
          >
            Commercial
          </Link>
          <Link
            to="/projects"
            data-testid="nav-projects"
            className={`transition-colors duration-300 hover:text-primary ${pathname.startsWith("/project") ? "text-primary" : "text-white/70"}`}
          >
            Projects
          </Link>
          <Link
            to="/review-proposal"
            data-testid="nav-my-proposal"
            className={`transition-colors duration-300 hover:text-primary ${pathname === "/review-proposal" ? "text-primary" : "text-white/70"}`}
          >
            My Proposal
          </Link>
          <button
            onClick={goQuote}
            data-testid="nav-get-quote"
            className="rounded-lg bg-primary text-primary-foreground px-4 md:px-6 py-2.5 font-bold uppercase tracking-widest text-xs transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(193,214,46,0.4)]"
          >
            Get Quote
          </button>
        </nav>
      </div>
    </motion.header>
  );
};
